import React from "react";
import {beginTestingYear} from "../TestTakerSearchUtils"
import moment from "moment"
import {School} from "@mui/icons-material"
import Tooltip from "@mui/material/Tooltip"
import {ReportSubPaths} from "../../../../ReportSubPaths"
import {useHistory} from "react-router"
import {AvantColors} from "../../../../../../styles/AvantColors"

export type ClassReportLinkProps = {
    classGroupId: number,
    productId: number,
}

export function ClassReportLink({classGroupId, productId}: ClassReportLinkProps)  {

    const history = useHistory()

    function navigateToClassReport() {
        const filters = {
            groupId: classGroupId,
            productId: productId,
            startDate: beginTestingYear(),
            endDate: moment(),
            /** This is the default flag setting for Class reports elsewhere. */
            assessmentStart: false,
            /** This is the default flag setting for Class reports elsewhere. */
            recentActivity: true,
        }
        history.push(
            `${ReportSubPaths.class(filters)}`
        )
    }

    return (
        <Tooltip title={"Class Report"}>
            <School onClick={navigateToClassReport} sx={{color: AvantColors.avantDarkGrey, cursor: "pointer"}}></School>
        </Tooltip>
    );

}